import { EntityId } from '../base';

export interface IPaymentHistory {
  id?: EntityId;
  author?: IPaymentFileAuthor;
  date?: Date;
  paymentFiles?: IPaymentFile[]
}

export interface IPaymentFile {
  fileName?: string;
  fileSize?: number;
  fileUrl?: string;
  fileExtension?: string;
  originalFileName?: string;
  succeed?: number;
  failed?: number;
}

export interface IPaymentFileAuthor {
  userId?: string;
  userName?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
}

export interface IPaymentFileEvent {
  id?: EntityId;
  author?: IPaymentFileAuthor;
  date?: Date;
  paymentFile: IPaymentFile;
}

export enum PaymentUploadQueryType {
  SUCCEED = 'SUCCEED',
  FAILED = 'FAILED',
  NONE = ' NONE'
}
